/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */

import React, { useContext, useState } from 'react';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { dataService } from '../../../../../services/data.services';
import moment from 'moment';
import { formatAdjustedDate } from '../../../../../CommonMethods/formatDate';

const TableBody = ({
    tableData, 
    indexNum, 
    setToastErrorMessage }) => {
    const {setToastmessage} =  useContext(GlobalContext);
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const [activateOpen, setActivateOpen] = useState(false);
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const handleConformationClick = () => {
        setActivateOpen(!activateOpen)
    }

    const handleOnCLickActivate = async () => {
        setActivateButtonLoading(true);
        try {
            let body = { }
            body = {
                "status": "inactive",
            }
            let endpoint= `inventory/${tableData._id}`
            const response = await dataService.PatchAPI(body,endpoint);
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastmessage(`Inventory item deactivated successfully`);

        } catch (error) {
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error(error);
        }    }

    return (
        <>
            <AnimatedList
                rowStatus={true}
                keyItem={indexNum}
                handleClick={()=>{}}
                child={
                    <>
                        <td class="text-start">{formatAdjustedDate(tableData?.grn_date)}</td>
                        <td class="text-start">{tableData?.grn_number || "-"}</td>
                        <td class="text-end">{Number(tableData?.cost_per_item).toFixed(2) || "-"}</td>
                        <td class="text-end">{tableData?.rcvd_quantity || "-"}</td>
                        <td class="text-end ">{tableData?.available_quantity || "0"}</td>
                        <td class="text-start">{tableData?.ledger || "-"}</td>
                        <td class="text-start">{tableData?.vendor_name || "-"}</td>
                        <td class="text-start">{tableData?.vendor_invoice || "-"}</td>

                    </>
                    
                }/>
            
            {activateOpen && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`Deactivate Inventory Item`}
                        message = {`Are you sure you want to deactivate the inventory item ${tableData?.item_name}?`}
                        buttonName = {`Deactivate`}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
        </>
        
    );
}

export default TableBody;
